import React, {useMemo} from 'react'
import {useTranslation} from 'i18n'
import {FirebaseMessageRoomItemPayload} from 'types'
import {Paragraph, ParsedText} from 'common/components'

export interface GiftShopMessageRoomContentItemNotificationRemoveFarmerProps {
  payload: FirebaseMessageRoomItemPayload['notification_remove_farmer']
}

export default function GiftShopMessageRoomContentItemNotificationRemoveFarmer({
  payload: {username, tree_name},
}: GiftShopMessageRoomContentItemNotificationRemoveFarmerProps) {
  const {translate} = useTranslation()
  const Pattern = (text: string) => useMemo(() => new RegExp(text), [text])

  return (
    <>
      <Paragraph fontSize="m">
        <ParsedText
          parse={[
            {
              pattern: Pattern(username),
              style: {fontFamily: 'roboto-bold'},
            },
          ]}>
          {translate('messages:hiUsername', {username})}
        </ParsedText>
      </Paragraph>
      <br />
      <Paragraph fontSize="m">
        <ParsedText
          parse={[
            {
              pattern: Pattern(tree_name),
              style: {fontFamily: 'roboto-bold'},
            },
          ]}>
          {translate('messages:notificationRemoveFarmer', {tree_name})}
        </ParsedText>
      </Paragraph>
    </>
  )
}
